import React, { useState, useEffect } from "react";
import SuccessCard from "./SuccessCard";
import CancelCard from "./CancelCard";
import { useDispatch } from "react-redux";
import { refreshUserSubscriptions } from "util/refreshUserSubscriptions";

const PaymentCard = () => {
  const [message, setMessage] = useState("");
  const [paymentStatus, setPaymentStatus] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setPaymentStatus("success");
      refreshUserSubscriptions(dispatch);
    }

    if (query.get("canceled")) {
      setPaymentStatus("canceled");
      setMessage("Order canceled -- continue to shop around and checkout when you're ready.");
    }
  }, []);

  // Render success card if payment was successful
  if (paymentStatus === "success") {
    return <SuccessCard />;
  }

  // Render cancel card if payment was cancelled
  if (paymentStatus === "canceled") {
    return <CancelCard />;
  }

  // Default state - could show loading or redirect to plans
  return (
    <div className="payment-card-wrapper">
      <p>Processing payment status...</p>
    </div>
  );
};

export default PaymentCard;